/*
 * Semantic status colours, one entry per mode.
 *
 * Consumed only by compileTheme, which picks a mode and exposes the result as
 * `theme.emotive`. Never import this file from a component — a module-scope read
 * cannot see the active theme, which is how the dark-mode chips in TotalWidget
 * and the invoice PAID/UNPAID pill ended up hardcoded to their light values.
 *
 * Five roles per state:
 *   color    text / icon / dot — solid, carries the meaning
 *   bg       resting surface — alpha, so it composites over a hovered or tinted row
 *   bgHover  the same surface one step up, for a hoverable row
 *   border   pill and chip outline — alpha, matched to bg
 *   surface  opaque panel fill. Use where something sits over the page rather than
 *            on it — a modal panel above its backdrop would show the page through
 *            an alpha bg. On an already-opaque parent prefer bg.
 */
const emotiveColors = {
    light: {
        success:  { color: '#067046', bg: 'rgba(8, 146, 91, 0.12)',    bgHover: 'rgba(8, 146, 91, 0.20)',    border: 'rgba(8, 146, 91, 0.22)',    surface: '#e0f0e9' },
        warning:  { color: '#783305', bg: 'rgba(227, 177, 26, 0.16)',  bgHover: 'rgba(227, 177, 26, 0.26)',  border: 'rgba(227, 177, 26, 0.34)',  surface: '#fdf0d5' },
        info:     { color: '#0d457a', bg: 'rgba(39, 102, 241, 0.10)',  bgHover: 'rgba(39, 102, 241, 0.18)',  border: 'rgba(39, 102, 241, 0.22)',  surface: '#e4edfd' },
        error:    { color: '#aa1100', bg: 'rgba(170, 17, 0, 0.10)',    bgHover: 'rgba(170, 17, 0, 0.18)',    border: 'rgba(170, 17, 0, 0.20)',    surface: '#fae3e0' },
        disabled: { color: '#6b7280', bg: 'rgba(105, 117, 136, 0.10)', bgHover: 'rgba(105, 117, 136, 0.18)', border: 'rgba(105, 117, 136, 0.22)', surface: '#ebedf0' }
    },
    dark: {
        success:  { color: '#47c394', bg: 'rgba(71, 195, 148, 0.16)',  bgHover: 'rgba(71, 195, 148, 0.26)',  border: 'rgba(71, 195, 148, 0.32)',  surface: '#16241f' },
        warning:  { color: '#f0c355', bg: 'rgba(240, 195, 85, 0.16)',  bgHover: 'rgba(240, 195, 85, 0.26)',  border: 'rgba(240, 195, 85, 0.30)',  surface: '#2a2418' },
        info:     { color: '#6ea8fe', bg: 'rgba(110, 168, 254, 0.16)', bgHover: 'rgba(110, 168, 254, 0.26)', border: 'rgba(110, 168, 254, 0.30)', surface: '#17202e' },
        error:    { color: '#ff7264', bg: 'rgba(255, 114, 100, 0.16)', bgHover: 'rgba(255, 114, 100, 0.26)', border: 'rgba(255, 114, 100, 0.32)', surface: '#2a1a17' },
        disabled: { color: '#9aa3ad', bg: 'rgba(154, 163, 173, 0.12)', bgHover: 'rgba(154, 163, 173, 0.20)', border: 'rgba(154, 163, 173, 0.26)', surface: '#1d1f22' }
    }
}

export default emotiveColors
